import React from 'react';
import classNames from 'classnames';
import { cloudinaryImageUrl } from '@scentregroup/ui/tools/cloudinary/image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const getCloudinaryImageUrl = backgroundImage => cloudinaryImageUrl({
  src: backgroundImage,
  numberofItems: 1,
  ratio: 'standard'
});

const ContentGroup = _ref => {
  let {
    children,
    backgroundImage,
    skipTopPadding,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(className, style.Group, style.evolved, {
      [style.backgroundImage]: backgroundImage,
      [style.skipTopPadding]: skipTopPadding
    }),
    style: backgroundImage ? {
      backgroundImage: "url(".concat(getCloudinaryImageUrl(backgroundImage), ")")
    } : null,
    "data-id": "content-group_index_ContentGroup_div",
    children: children
  });
};

ContentGroup.defaultProps = {
  skipTopPadding: false
};
export default ContentGroup;